import pluralize from 'pluralize';

import { ValidationError } from 'src/enums/Validation';

export const getMaxFieldLengthErrorMessage = (length: number): string => {
  const pluralizedLength = pluralize('character', length);
  return `${ValidationError.maxFieldLength} ${length.toLocaleString('en-US')} ${pluralizedLength}`;
};
